import React, { FC } from "react";
import { StepFourParams } from "../../../Pages/MyAppointment/Steps/StepFourParams.csharp";

interface StepFourProps extends StepFourParams {
  onClose: () => void;
}

export const ExitStep: FC<StepFourProps> = ({ onClose, title, content }) => {
  return (
    <>
      <h2>{title}</h2>
      <div dangerouslySetInnerHTML={{ __html: content }} />
      <button className="btn btn-primary mt-3 mb-1" onClick={onClose}>
        Steng vindu
      </button>
    </>
  );
};
